import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DashGridCell = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;

  > *:first-child {
    height: 100% !important;
    min-height: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    animation: none !important;
  }
`

export const DashEditScrim = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  cursor: grab;
  border-radius: ${tokens.radius.card};
  &:active {
    cursor: grabbing;
  }
`

export const DashboardModalContainer = styled.div`
  width: max-content;
  height: 100vh;
  position: fixed;
  top: 0;
  animation: slide-right 0.2s ease-in forwards;
  pointer-events: all;
  padding: 2rem 1rem;
  ${(props) => props.theme.container};
  @keyframes slide-right {
    from {
      right: -30%;
      opacity: 0;
    }
    to {
      right: 0;
      opacity: 1;
    }
  }

  @media (max-width: 1020px) {
    width: 100vw !important ;
  }
`

export const DashboardSectionsContainer = styled.div`
  display: flex;
  gap: 1rem;
  height: 50%;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`

export const DBCardsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`

export const DashboardModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 9;
  /* background-color: #6497c866; */
`

export const DashboardModalHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20%;

  & > div {
    display: flex;
    gap: 1rem;

    svg {
      stroke: ${tokens.status.danger.fg};
    }
  }
`

interface IDashboardModalContent {
  width?: string
}

export const DashboardModalContent = styled.div<IDashboardModalContent>`
  width: ${(props) => props.width ?? '30vw'};
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-height: 100%;
  overflow: auto;
  padding-bottom: 2rem;
`

export const DashboardModalArrow = styled.div`
  display: flex;
  align-items: center;
  padding-left: 5px;
  cursor: pointer;
  svg {
    transform: scale(1.3);
  }
`

interface IEmployeeDetailsUpper {
  columns: number
}
export const EmployeeDetailsUpper = styled.div<IEmployeeDetailsUpper>`
  height: fit-content;
  min-height: 30vh;
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) => 'repeat(' + props.columns + ',1fr)'};
  gap: 1.5rem;

  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    min-height: none !important;
    height: auto !important;
  }
`

export const EmployeDetailsCard = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: 7rem;
  height: 7rem;
  display: flex;
  align-items: center;
  padding: 10px 1rem;
  ${(props) => props.theme.content};

  @media (max-width: 500px) {
    height: max-content;
    flex-direction: column;
    padding: 15px 1rem;
  }
`

interface IEDCDetails {
  column?: boolean
}
export const EDCDetails = styled.div<IEDCDetails>`
  width: 74%;
  height: max-content;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  border-left: 0.5px solid ${tokens.text.secondary};
  ${(props) => props.column && 'flex-direction:column;'}

  @media (max-width: 500px) {
    border: none;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    font-size: 0.7rem;
    gap: 5px;
    * {
      padding: 0;
    }
  }
`
export const EDCDetailsIcon = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transform: scale(2);
    fill: ${tokens.accent.base};
    stroke-width: 1;
  }
`
export const EmployeeDetailsProfile = styled(EmployeDetailsCard)`
  box-shadow: none;
  max-height: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 1rem;
  overflow: hidden;
  border-radius: none;
  background-color: none;
  img {
    height: 80%;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: 50%;
  }

  div {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 500px) {
    height: 20rem;
    overflow: visible;
    min-height: 15rem;
    img {
      width: 50%;
      height: unset;
    }
    div {
      align-items: center;
    }
  }
`

export const WidgetsSidebarContainer = styled.div`
  overflow: auto;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
  transition: 0.2s ease-in;
  padding: 1rem;
  ${(props) => props.theme.container}
`

export const WidgetsGrid = styled.div`
  min-width: 0;
  width: 100%;
  height: auto;
  display: grid;
  gap: 1rem;
  grid-auto-rows: minmax(16rem, auto);
  grid-auto-columns: 1fr;

  @media (max-width: 1020px) {
    display: flex;
    flex-direction: column;
  }
`

export const PlaceholderContainer = styled.div`
  width: 1fr;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-in;
  position: relative;
  border-radius: ${tokens.radius.card};

  p {
    font-size: 0.8rem;
    color: ${tokens.text.muted};
    width: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const WidgetsSelectItem = styled.div`
  width: 100%;
  display: flex;
  padding: 1rem;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  color: ${tokens.text.primary};
  ${(props) => props.theme.content};
  border-radius: ${tokens.radius.card};
  .text {
    display: flex;
    gap: 5px;
    flex-direction: column;

    p {
      font-size: 0.8rem;
    }
  }

  &:hover {
    outline: 1px solid ${tokens.accent.base};
  }
`

export const WidgetEditOverlay = styled.div`
  background-color: #000000cc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 10%;
  animation: 0.5s slideInFromTop forwards;
  cursor: pointer;
  z-index: 999;

  p {
    color: ${tokens.text.primary};
    width: 100%;
    font-size: 0.9rem;
  }

  @keyframes slideInFromTop {
    0% {
      transform: translateY(-100%);
      opacity: 0;
    }
    60% {
      transform: translateY(20px); /* Slight bounce effect */
      opacity: 1;
    }
    100% {
      transform: translateY(0);
    }
  }
`

export const SingleDBEmployeeTopSection = styled.div`
  ${(props) => props.theme.container};
  height: 12.5rem;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  @media (max-width: 1400px) {
    flex-direction: column;
    align-items: start;
    height: auto;
  }

  @media (max-width: 1110px) {
    align-items: center;
  }

  & > div {
    @media (max-width: 1110px) {
      flex-direction: column;
      align-items: center;
      height: auto;

      .details {
        text-align: center;

        .role {
          justify-content: center;
          margin-bottom: 1rem;
        }
      }
    }
  }
`

export const EmployeeSchedulecContainer = styled.div`
  display: flex;
  gap: 1rem;
  @media (max-width: 1110px) {
    justify-content: center;
    overflow: auto;
  }

  @media (max-width: 935px) {
    justify-content: start;
  }
`

export const EmployeePicture = styled.div`
  min-width: 10rem;
  max-width: 10rem;
  height: 10rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  background: linear-gradient(145deg, ${tokens.accent.base}, ${tokens.accent.ink});
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`

export const ScheduleCard = styled.div<{ color?: string; null?: boolean }>`
  width: 100%;
  height: 3.125rem;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${(props) => (props.null ? tokens.surface.inset : props.color ?? tokens.accent.base)};
  border-radius: ${tokens.radius.card};
  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
`
export const DBSingleEmployeeSection = styled.div<{ lastTasks?: boolean }>`
  position: relative;
  ${(props) => props.theme.container};
  width: 100%;
  height: 16.25rem;
  border-radius: ${tokens.radius.card};
  border-top: 1px solid ${tokens.accent.base};
  padding: 1rem;
  overflow: hidden;
`
export const DashboardRewardPointsContainer = styled.div`
  background-color: ${tokens.accent.base};
  border-radius: 50px;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    width: 0; /* This forces the element to shrink */
    flex-grow: 1; /* Allow it to grow to fill available space */
    text-align: center;
    margin: 0;
    padding: 0 8px;
  }
`

export const DashboardRangePicker = styled.div`
  width: 100px;
  height: 32px;
  border-radius: ${tokens.radius.control};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${tokens.surface.raised};
  backdrop-filter: blur(13.2px);
  border-radius: ${tokens.radius.chip};
  position: relative;
  cursor: pointer;
  z-index: 99999;

  .dropdown {
    position: absolute;
    top: 105%;
    left: 0;
    display: flex;
    flex-direction: column;
    border-radius: ${tokens.radius.chip};
    background: ${tokens.surface.raised};
    width: 100%;
    overflow: hidden;
  }

  .option {
    cursor: pointer;
    height: 32px;
    width: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    &:hover {
      background: ${tokens.surface.inset};
    }
  }
`
export const NoAvailableData = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.noDataAvailableBackground};
  opacity: 0.78;
  background: ${(props) => props.theme.noDataAvailableBackground};
  backdrop-filter: blur(15px);
  z-index: 99999999999;
`

export const BasicInfoSectionScrollContainer = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  &:hover {
    overflow-y: auto; /* Only vertical */
    overflow-x: hidden; /* Disable horizontal */
  }

  @media (max-width: 700px) {
    & > div {
      flex-direction: column;
    }
  }
`

export const EmployeeHeaderCard = styled.div`
  ${(props) => props.theme.container};
  width: 100%;
  padding: 1.25rem 1.5rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border-radius: ${tokens.radius.card};
`

export const EmployeeHeaderTopRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const EmployeeHeaderIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const EmployeeHeaderAvatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`

export const EmployeeHeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .name {
    font-size: 24px;
    font-weight: 700;
    color: ${tokens.accent.base};
    line-height: 1.2;
  }

  .role-row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    letter-spacing: 0.08em;

    .role {
      text-transform: uppercase;
      color: ${tokens.text.primary};
      font-weight: 500;
    }

    .status {
      display: flex;
      align-items: center;
      gap: 6px;
      color: ${tokens.text.primary};

      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${tokens.status.success.fg};
      }
    }
  }
`

export const EmployeeHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
`

export const EmployeePointsPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid ${tokens.accent.base};
  background: transparent;
  color: ${tokens.accent.base};
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;

  svg path {
    fill: ${tokens.accent.base};
  }

  .label {
    font-size: 11px;
    letter-spacing: 0.08em;
    opacity: 0.85;
  }

  .value {
    font-weight: 700;
  }
`

export const EmployeeRatingInline = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 22px;
    height: 22px;
  }

  svg path {
    fill: ${tokens.accent.base};
    stroke: ${tokens.accent.base};
  }

  .value {
    font-size: 20px;
    font-weight: 700;
    color: ${tokens.text.primary};
  }
`

export const EmployeeShiftsRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 2px;

  ::-webkit-scrollbar {
    height: 4px;
  }
`

export const EmployeeShiftCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 116px;
  flex: 1;

  .day-label {
    font-size: 11px;
    color: ${tokens.text.secondary};
  }
`

export const IconContainer = styled.div<{ color?: string }>`
  width: 32px;
  height: 32px;
  display: grid;
  align-items: center;
  justify-items: center;
  background: ${(props) => props.color};
  border-radius: 6px;
`

export const EmployeeTabPanel = styled.div`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export const EmployeeInfoGrid = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns ?? 3}, 1fr)`};
  gap: 1.5rem 2rem;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 550px) {
    grid-template-columns: 1fr;
  }
`

export const EmployeeInfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  .field-label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: ${tokens.text.secondary};
  }

  .field-value {
    font-size: 14px;
    color: ${tokens.text.primary};
    word-break: break-word;
  }
`

export const EmployeeSectionHeading = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: ${tokens.text.primary};
  grid-column: 1 / -1;
  margin-top: 0.5rem;
`

export const EmployeeStatCardsRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
`

export const EmployeeStatCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: ${tokens.radius.card};
  ${(props) => props.theme.content};
  min-width: 180px;

  .stat-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .stat-label {
    font-size: 11px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: ${tokens.text.secondary};
    font-weight: 500;
  }

  .stat-value {
    font-size: 20px;
    font-weight: 700;
    color: ${tokens.text.primary};
  }

  .stat-value-sub {
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.text.secondary};
  }
`

export const EmployeeOverviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 1rem;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const EmployeeOverviewMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`

export const EmployeeOverviewSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const EmployeeContractSummaryCard = styled.div`
  ${(props) => props.theme.content};
  padding: 1.25rem 1.5rem;
  border-radius: ${tokens.radius.card};
  display: flex;
  align-items: center;
  gap: 1.25rem;
  width: 100%;

  .icon-wrap {
    flex-shrink: 0;
  }

  .rows {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem 1.5rem;
    width: 100%;

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`

export const EmployeeSideCard = styled.div`
  ${(props) => props.theme.content};
  padding: 1.25rem;
  border-radius: ${tokens.radius.card};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  .side-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      font-weight: 600;
      color: ${tokens.text.primary};
      letter-spacing: 0.04em;
    }

    .view-all {
      display: flex;
      align-items: center;
      gap: 4px;
      color: ${tokens.text.secondary};
      font-size: 12px;
      cursor: pointer;
    }
  }
`

export const EmployeeTaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const EmployeeTaskRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .task-name {
    font-size: 13px;
    color: ${tokens.text.primary};
  }

  .task-header {
    font-size: 11px;
    letter-spacing: 0.08em;
    color: ${tokens.text.secondary};
    text-transform: uppercase;
    font-weight: 500;
  }
`

export const EmployeeTaskStatusBadge = styled.span<{ status?: 'completed' | 'progress' | 'open' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  ${(props) => {
    if (props.status === 'completed') {
      return `
        background: ${tokens.status.success.bg};
        color: ${tokens.status.success.fg};
      `
    }
    if (props.status === 'progress') {
      return `
        background: ${tokens.status.accent.bg};
        color: ${tokens.accent.base};
      `
    }
    return `
      background: ${tokens.status.info.bg};
      color: ${tokens.status.info.fg};
    `
  }}
`

export const EmployeeTodayStatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .info-label {
      font-size: 11px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: ${tokens.text.secondary};
      font-weight: 500;
    }

    .info-value {
      font-size: 13px;
      color: ${tokens.text.primary};
      font-weight: 500;
    }
  }
`

export const EmployeeActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const EmployeeActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .activity-text {
    flex: 1;
    font-size: 13px;
    color: ${tokens.text.primary};
  }

  .activity-time {
    font-size: 12px;
    color: ${tokens.text.secondary};
  }
`

export const EmployeeContractsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const EmployeeContractDownloadRow = styled.div`
  ${(props) => props.theme.content};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${tokens.border.hairline};
  min-width: 220px;

  .download-name {
    font-size: 13px;
    color: ${tokens.text.primary};
  }

  .download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg path {
      fill: ${tokens.text.primary};
    }
  }
`

export const EmployeeSectionTitle = styled.p`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${tokens.text.primary};
`
